import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import Modal from "Common/Components/Modal";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import { Plus, SearchIcon, X } from "lucide-react";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import Swal from "sweetalert2";
import DeleteModal from "Common/DeleteModal";
import PaginationTest from "Common/Components/Paginationtest";
import DynamicSelect from "Common/Components/DynamicSelect";
import GuaranteeCoulmn from "Common/Components/ColumnData/GuaranteeCoulmn";
import FarmerInfoForModal from "Common/FarmerInfoForModal";
import FarmerIdentityInfo from "Common/Components/FarmerIdentityInfo";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
const Guarantee2 = () => {
  const [AllData, setAllData] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [eventData, setEventData] = useState<any>();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [reload, setreload] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [totalPages, setTotalPages] = useState<number>(0);
  const token = localStorage.getItem("app_atkey");
  const [dataListFarmer, setdataListFarmer] = useState<any>([]);
  const [dataListFarmerGaranti, setdataListFarmerGaranti] = useState<any>([]);
  const [searchvalueSelect, setsearchvalesearchvalueSelect] = useState<any>();
  const [searchvalueSelectGaranti, setsearGaranti] = useState<any>();
  const [FarmerID, setFarmerID] = useState<any>();
  const [FarmerIDGaranti, setFarmerIDGaranti] = useState<any>();
  const [searchValue, setsearchValue] = useState<any>();
  const cropYearID = localStorage.getItem("crop_year_id");
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const [mainIDFarmer, setMainIDfarmer] = useState<any>(null);
  const [MainIDfarmerGarant, setMainIDfarmerGarant] = useState<any>(null);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [guarantee_price_default, setguarantee_price_default] =
    useState<any>(null);
  const [selectedFarmerInfo, setSelectedFarmerInfo] = useState<any>({
    amount_of_land: "",
    village_name: "",
    date_set: "",
  });
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  const sortLabels: any = {
    guarantee_price: "مبلغ ضمانت",
  };
  const [setSelectedFarmerInfoGaranti, setsetSelectedFarmerInfoGaranti] =
    useState<any>({
      amount_of_land: "",
      village_name: "",
      date_set: "",
    });

  useEffect(() => {
    const fetchFarmerInfo = async () => {
      try {
        setIsLoading(true);

        // اگر mainIDFarmer وجود داشت، درخواست اول را ارسال کن
        if (mainIDFarmer) {
          const res1 = await axios.get(
            `https://api.havirkesht.ir/commitment/${Number(mainIDFarmer)}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
              },
            }
          );
          console.log(res1, "✅✅✅✅✅");

          // پردازش پاسخ اول
          if (res1.data?.amount_of_land) {
            setSelectedFarmerInfo({
              amount_of_land: res1?.data.amount_of_land || "", // اگر null بود، خالی برگردان
              village_name: res1?.data?.village_name || "",
              date_set: res1?.data?.date_set || "",
            });
          }
        }

        // اگر MainIDfarmerGarant وجود داشت، درخواست دوم را ارسال کن
        if (MainIDfarmerGarant) {
          const res2 = await axios.get(
            `https://api.havirkesht.ir/commitment/${Number(
              MainIDfarmerGarant
            )}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
              },
            }
          );
          // پردازش پاسخ دوم
          if (res2.data?.date_set) {
            setsetSelectedFarmerInfoGaranti({
              amount_of_land: res2?.data.amount_of_land || "", // اگر null بود، خالی برگردان
              village_name: res2?.data?.village_name || "",
              date_set: res2?.data?.date_set || "",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching farmer info:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFarmerInfo();
  }, [mainIDFarmer, MainIDfarmerGarant]);
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  useEffect(() => {
    const getData = async () => {
      // بررسی وجود FarmerIDGaranti قبل از درخواست
      if (!FarmerIDGaranti) {
        console.log("FarmerIDGaranti معتبر نیست");
        return;
      }
      try {
        const res = await axios.get(
          `https://api.havirkesht.ir/farmers_guarantee/default-price/${FarmerIDGaranti}?&crop_year_id=${cropYearID}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        console.log(res.data, "داده‌های دریافت شد");
        setguarantee_price_default(res?.data?.guarantee_price_default);
      } catch (error) {
        console.error("خطا در دریافت داده:", error);
      }
    };
    getData();
  }, [FarmerIDGaranti]);

  const fetchPayments = async (page: number, size: number) => {
    setIsLoading(true);
    try {
      const base = "https://api.havirkesht.ir/farmers_guarantee/";
      const params = new URLSearchParams();

      params.set("size", String(size));
      params.set("page", String(page));
      if (cropYearID != null) params.set("crop_year_id", String(cropYearID));

      // فقط یک سرچ: اولویت با searchValue.trim()، بعد searchValue
      const term =
        (typeof searchQuery === "string" && searchQuery.trim()) ||
        (typeof searchQuery === "string" && searchQuery.trim()) ||
        "";
      if (term) params.set("search", term);

      // سورت هماهنگ با step
      if (sortState) {
        if (sortState.step === 2) {
          params.set("sort_by", "created_at");
          params.set("sort_order", "desc");
        } else {
          // step 0 یا 1
          const by = sortState.name || "updated_at";
          const order = sortState.order === "asc" ? "asc" : "desc";
          params.set("sort_by", by);
          params.set("sort_order", order);
        }
      }

      const url = `${base}?${params.toString()}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      setAllData(response.data?.items);
      setTotalItems(response.data?.total || 0);
      setTotalPages(response?.data?.pages);
    } catch (error) {
      console.error("خطا در دریافت پرداخت‌ها:", error);
      toast.error("خطا در بارگذاری پرداخت‌ها");
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    // استفاده از totalItems به جای payments
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setPageSize(newSize);
    setCurrentPage(newPage);

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchPayments(newPage, newSize);
  };

  useEffect(() => {
    fetchPayments(currentPage, pageSize);
  }, [currentPage, pageSize, searchQuery, reload, sortState]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${cropYearID}`;
        if (
          searchvalueSelectGaranti &&
          searchvalueSelectGaranti.trim() !== ""
        ) {
          url += `&search=${encodeURIComponent(
            searchvalueSelectGaranti.trim()
          )}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListFarmerGaranti(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [searchvalueSelectGaranti]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${cropYearID}`;
        if (searchvalueSelect && searchvalueSelect.trim() !== "") {
          url += `&search=${encodeURIComponent(searchvalueSelect.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListFarmer(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [searchvalueSelect]);

  const onGaranti = async (farmerID: any) => {
    const result = await Swal.fire({
      title: "تایید رفع ضمانت",
      text: "با تایید رفع ضمانت، مبلغ ضمانت برای این کشاورز صفر میشود. آیا از رفع ضمانت این کشاورز مطمئن هستید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton:
          "bg-green-500 rounded-md   p-2 hover:bg-green-600 text-white mr-2",
        cancelButton: "bg-red-500 p-2  rounded-md hover:bg-red-600 text-white",
      },
      buttonsStyling: false,
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("app_atkey");
        const response = await axios.patch(
          `https://api.havirkesht.ir/farmers_guarantee/${farmerID.id}/clear-guarantee`,
          // { guarantee_price: 0 }, // Set guarantee price to 0
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);

        Swal.fire({
          title: "موفق!",
          text: "ضمانت با موفقیت رفع شد.",
          icon: "success",
          confirmButtonText: "تایید",
        }).then(() => {
          // Optional: Refresh data or update UI
          setreload(!reload);
        });
      } catch (error) {
        console.error("Error removing guarantee:", error);
        Swal.fire({
          title: "خطا!",
          text: "عملیات رفع ضمانت با خطا مواجه شد.",
          icon: "error",
          confirmButtonText: "تایید",
        });
      }
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };
  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await axios.delete(
          `https://api.havirkesht.ir/farmers_guarantee/${Number(eventData)}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        setreload(!reload);
        if (res.status === 200) {
          Swal.fire({
            title: "حذف  ضمانت کشاورز",
            text: "عملیات حذف با موفقیت انجام شد",
            icon: "success",
          });
          setDeleteModal(false);
        } else {
          Swal.fire({
            title: "حذف  ضمانت کشاورز",
            text: "مشکلی در حذف به وجود امده است",
            icon: "error",
          });
        }
        setEventData(null);
      } catch (error) {
        toast.error("مشکل در حذف داده ");
      }
    }
  };

  // فرم ثبت ضمانت کشاورز جدید
  const formik = useFormik({
    initialValues: {
      priceGaranti: guarantee_price_default ? guarantee_price_default : null,
    },
    onSubmit: async (values) => {
      if (!FarmerID || !FarmerIDGaranti) {
        setShowModal(true);
        return Swal.fire({
          title: "خطا در ثبت ",
          text: "لطفا کشاورز ضامن و کشاورز ضمانت شده را انتخاب کنید",
          icon: "error",
        });
      }
      try {
        const payload = {
          guarantee_price: guarantee_price_default,
          guarantor_farmer_id: FarmerID, // ضامن کشاورز
          guaranteed_farmer_id: Number(FarmerIDGaranti),
          crop_year_id: Number(cropYearID),
        };
        const response = await axios.post(
          "https://api.havirkesht.ir/farmers_guarantee/",
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.status === 201) {
          Swal.fire({
            title: "ثبت ضمانت کشاورز",
            text: "ثبت ضمانت کشاورز با موفقیت ثبت شد",
            icon: "success",
          });
          values.priceGaranti = "";
          resetDataID();
          setguarantee_price_default(null);
          formik.resetForm();
        }
      } catch (error: any) {
        resetDataID();
        if (error.status === 400) {
          setShowModal(false);
          return Swal.fire({
            title: "خطا در عملیات ضمانت کشاورز",
            text: "کشاورز با سال زراعی ارسال شده قرارداد ندارد",
            icon: "error",
          });
        }
        Swal.fire({
          title: "عملیات ضمانت کشاورز",
          text: "خطا در ثبت ضمانت کشاورزان:",
          icon: "error",
        });
        console.error(error);
      }
    },
  });

  const formatNumber = (num: number | string) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString()?.replace(/,/g, "");
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum?.replace(/,/g, "");
  };
  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        // اگر روی همان ستون کلیک شد
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        console.log(nextStep, "nextStep");
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name, order: "desc", step: 0 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        // اگر ستون جدیدی انتخاب شد
        return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
      }
    });
    setreload(!reload);
  };
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  const columns = GuaranteeCoulmn({ onClickDelete, onGaranti, columnName });

  function resetDataID() {
    setShowModal(false);
    setMainIDfarmer(null);
    setMainIDfarmerGarant(null);
    setguarantee_price_default(null);
    setFarmerID(null);
    setreload(!reload);
    setFarmerIDGaranti(null);
    setsearGaranti(null);
    searchvalueSelectGaranti(null);
  }
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="مدیریت ضمانت کشاورزان" title="پنل مدیریت" />
      <ToastContainer rtl={true} />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <div className="card" id="paymentTable">
        <div className="card-body">
          <div className="flex flex-col md:flex-row gap-3 mb-4 items-center">
            <h6 className="text-15 grow">
              تعداد ضمانت کشاورزان: <b>{totalItems}</b>
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جستجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <SearchIcon
                    size={15}
                    className="absolute inset-y-0 top-2 left-2 flex items-center text-gray-400"
                  />
                </div>
              </label>
            </h6>
            <div className="w-full sm:w-auto">
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <div className="shrink-0">
              <button
                onClick={() => setShowModal(true)}
                className="text-white btn bg-blue-500 border-blue-500 hover:text-white hover:bg-blue-600"
              >
                <span className="align-middle">ثبت ضمانت کشاورز </span>
                <Plus className="inline-block size-4" />
              </button>
            </div>
          </div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${
                    sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                  }`}
            </div>
          )}
          {AllData.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={AllData}
              customnumberfortable={12}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={isLoading ? 10 : 0}
              text={
                isLoading ? "در حال بارگذاری..." : "ضمانت کشاورزانی یافت نشد"
              }
            />
          )}
        </div>
      </div>
      <div className="mb-2">
        <PaginationTest
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="fixed inset-0 flex items-center justify-center z-[9999]  bg-opacity-gray-50 backdrop-blur-sm"
        dialogClassName="relative w-full max-w-md bg-white dark:bg-zink-600 rounded-lg shadow-xl mx-4 my-8"
      >
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-500">
          <Modal.Title className="text-xl font-semibold">
            ثبت ضمانت کشاورز جدید
          </Modal.Title>
          <button
            onClick={() => setShowModal(false)}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          ></button>
        </Modal.Header>

        <Modal.Body className="p-6 overflow-y-auto max-h-[70vh]">
          <form onSubmit={formik.handleSubmit}>
            <div className="flex mb-3 flex-col gap-2">
              <label
                htmlFor="farmer"
                className="text-base font-medium dark:text-white"
              >
                کشاورز ضامن :
              </label>
              <DynamicSelect
                FarmerID={FarmerID}
                dataListFarmer={dataListFarmer || []}
                onChange={setFarmerID}
                setMainIDfarmer={setMainIDfarmer}
                onInputChange={setsearchvalesearchvalueSelect}
                inputValue={searchvalueSelect}
              />
              {mainIDFarmer && (
                <div className="mt-3">
                  {isLoading ? (
                    <span className="bg-green-200 dark:bg-zink-600 p-2 rounded-md text-xs text-gray-500 ">
                      {" "}
                      در حال دریافت داده ...
                    </span>
                  ) : (
                    <FarmerInfoForModal
                      selectedFarmerInfo={selectedFarmerInfo}
                    />
                  )}
                </div>
              )}
              <FarmerIdentityInfo farmerId={FarmerID} cropYearId={cropYearID} />
            </div>
            <div className="space-y-4">
              <div>
                <label className="block mb-2 text-right font-medium">
                  کشاورز ضامن شده :
                </label>
                <DynamicSelect
                  FarmerID={FarmerIDGaranti}
                  dataListFarmer={dataListFarmerGaranti || []}
                  onChange={setFarmerIDGaranti}
                  onInputChange={setsearGaranti}
                  setMainIDfarmer={setMainIDfarmerGarant}
                  inputValue={searchvalueSelectGaranti}
                />
                {MainIDfarmerGarant && (
                  <div className="mt-3">
                    {isLoading ? (
                      <span className="bg-green-200 dark:bg-zink-600 p-2 rounded-md text-xs text-gray-500 ">
                        {" "}
                        در حال دریافت داده ...
                      </span>
                    ) : (
                      <FarmerInfoForModal
                        selectedFarmerInfo={setSelectedFarmerInfoGaranti}
                      />
                    )}
                  </div>
                )}
                <FarmerIdentityInfo
                  farmerId={FarmerIDGaranti}
                  cropYearId={cropYearID}
                />
              </div>
              <div>
                <label className="block mb-2 text-right font-medium">
                  مبلغ ضمانت
                </label>
                <input
                  type="text"
                  name="priceGaranti"
                  value={formatNumber(guarantee_price_default)}
                  onChange={(e) => {
                    const rawValue = parseFormattedNumber(e.target.value);
                    if (!isNaN(Number(rawValue))) {
                      setguarantee_price_default(rawValue);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  className="w-full dark:text-gray-800 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="  مبلغ ضمانت را وارد کنید"
                />
              </div>
              <div className="">
                سال زراعی انتخاب شده:{" "}
                <span className="text-custom-600 dark:text-gray-200 bold">
                  {YearCoptSelect ? YearCoptSelect : ""}{" "}
                </span>
              </div>
            </div>

            <div className="mt-8 flex justify-center">
              <button
                type="submit"
                className="px-8 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                disabled={isLoading}
              >
                {isLoading ? "در حال ثبت..." : "ثبت ضمانت "}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Guarantee2;
